// removed by extract-text-webpack-plugin
module.exports = {"suggestion-content":"AutosuggestModelItem-module-suggestion-content-kIBlD","suggestionContent":"AutosuggestModelItem-module-suggestion-content-kIBlD","name":"AutosuggestModelItem-module-name-2aFJ6","car-years":"AutosuggestModelItem-module-car-years-1I2kp","carYears":"AutosuggestModelItem-module-car-years-1I2kp","car-years-label":"AutosuggestModelItem-module-car-years-label-1WDfM","carYearsLabel":"AutosuggestModelItem-module-car-years-label-1WDfM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AutosuggestModel/components/AutosuggestModelItem/AutosuggestModelItem.module.scss
// module id = 1003
// module chunks = 0